export default __webpack_public_path__ + "static/media/Group 3041@2x.a593f3a2.png";